import { render, staticRenderFns } from "./invoiceSingle.vue?vue&type=template&id=3818a674&scoped=true&"
import script from "./invoiceSingle.vue?vue&type=script&lang=js&"
export * from "./invoiceSingle.vue?vue&type=script&lang=js&"
import style0 from "./invoiceSingle.vue?vue&type=style&index=0&id=3818a674&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3818a674",
  null
  
)

export default component.exports